<svelte:head>
    <title>{$i18n.title}</title>
</svelte:head>

<EmptyHeader />

<ContentBlock contentAreaLayout="narrow"
    headingLevel="h1"
    title={$i18n.title}
    backLinkUrl={getBackLink()}
    backLinkText={$i18n.back}>

    <div class="itsl-forgotten-password">
    
        <Banner closable={true} bind:visible={emailSent} text={$i18n.emailHasBeenSent} close={$i18n.close}/>

        <Banner closable={true} bind:visible={errorOccured} text={$i18n.somethingWentWrong} type="warning" close={$i18n.close} />

        <fieldset class="itsl-forgotten-password__fieldset {emailSent || errorOccured ? 'itsl-forgotten-password__spacing' : ''}">
            {#if $store.siteDropdownVisible}
                <div class="itsl-forgotten-password__customer-selector">
                    <Select 
                            label={$i18n.selectYourMembership}
                            bind:value={customerId}
                            required={true}>
                        <option value=""></option>
                        {#each $store.sites as site}
                            <option value={site.value}>{site.name}</option>
                        {/each}
                    </Select>
                </div>
            {/if}

            <p>{$i18n.enterYourEmailInfo}</p>

            <div class="itsl-forgotten-password__email-field">
                <TextField id="email"
                    label={$i18n.enterYourEmail}
                    bind:value={email}
                    type="email" 
                    autocomplete="on"
                    maxlength={255}
                    errorMessage={emailError}
                    hasError={hasEmailError} />
            </div>
        </fieldset>
        
        <div class="itsl-forgotten-password__buttons">
            <Button
                type="primary"
                text={$i18n.sendRequest}
                on:click={sendRequest}
                htmlType="button"
                loading={loading}
            />
        </div>
    </div>

</ContentBlock>

{#if $store.allowResettingFromOtherSite}
    <Page contentAreaLayout="narrow">
        <AccountOnAnotherSite
            title={$i18n.accountNotConnectedToEmail}
            description={$i18n.accountNotConnectedToEmailDetails}
            selectYourSchoolOrSite={$i18n.selectYourSchoolOrSite}
            buttonText={$i18n.resetFromAnotherOrganisation}
            {redirectUrl}
            {currentCustomerId}
            submitButtonType='secondary'
            buttonCssClass='itsl-forgotten-password__buttons'
        >
            <Banner closable={true} bind:visible={accessExpired} text={$i18n.accessExpired} type="warning" close={$i18n.close} />
        </AccountOnAnotherSite>

    </Page>
{/if}

<script>
    import { post } from '@itslearning/atlas/network/fetch';
    import { validateEmail } from '@itslearning/atlas/validation/emailValidation';
    import { createEventDispatcher } from 'svelte';

    import AccountOnAnotherSite from "@its-ui/common-components/AccountOnAnotherSite/AccountOnAnotherSite.svelte";
    import Banner from '@itslearning/prometheus/assets/feedback/Banner/v1/Banner.svelte';
    import Button from '@itslearning/prometheus/assets/inputs/Button/v1/Button.svelte';
    import ContentBlock from '@itslearning/prometheus/assets/templates/ContentBlock/v1/ContentBlock.svelte';
    import EmptyHeader from '@itslearning/prometheus/assets/nodes/EmptyHeader/v1/EmptyHeader.svelte';
    import Page from "@itslearning/prometheus/assets/templates/Page/v1/Page.svelte";
    import Select from '@itslearning/prometheus/assets/inputs/Select/v1/Select.svelte';
    import TextField from '@itslearning/prometheus/assets/inputs/TextField/v1/TextField.svelte';

    import { i18n, store } from '@its-ui/forgotten-password/src/store';

    /** @type {String} */
    let email;

    let loading = false;
    let emailSent = false;
    let errorOccured = false;
    export let accessExpired = false;

    let customerId;
    let showErrorIfEmpty = false;
    let currentCustomerId = $store.currentCustomerId;

    $: emailError = getEmailError(email, showErrorIfEmpty);
    $: hasEmailError = !!emailError;

    function getEmailError(email, showErrorIfEmpty) {
        if (!showErrorIfEmpty && !email) {
            return ;
        }
        
        if (!email) {
            return $i18n.incorrectEmail;
        }

        return validateEmail(email)
            ? ''
            : $i18n.incorrectEmail;
    }

    async function sendRequest() {
        if (loading) {
            return;
        }

        showErrorIfEmpty = true;

        if (getEmailError(email, showErrorIfEmpty)) {
            return;
        }

        if ($store.siteDropdownVisible && !customerId) {
            return;
        }

        const request = {
            email
        };

        if ($store.siteDropdownVisible) {
            request.customerId = customerId;
        }

        loading = true;

        try
        {
            await post($store.sendEmailUrl, request);
            emailSent = true;
        }
        catch {
            errorOccured = true;
        }
        finally {
            loading = false;
            document.querySelector('#prom-input-email').focus();
        }
    }

    function getBackLink() {
        let backUrl = $store.backUrl;

        if ($store.siteDropdownVisible && customerId) {
            backUrl = backUrl.includes('?') 
                ? `${backUrl}&customerId=${customerId}`
                : `${backUrl}?customerId=${customerId}`;
        }

        return backUrl;
    }

    const dispatch = createEventDispatcher();

    const redirectUrl = (customerId) => `/resetpassword/verifyidentity?customerId=${customerId}`;
</script>
